module.exports = __webpack_public_path__ + "img/Bolivia.c369ac72.png";